/**
 * Event
 * Dispatcher
 */

class EventDispatcher {

	static trigger ( target, event, bubbling = true, cancelable = true, data = null ) {

		let e;

		if (window.CustomEvent && !window.isIE) {
		 	e = new CustomEvent(event, { bubbles: bubbling, cancelable: cancelable, detail: data });
		} else {
		 	e = document.createEvent('CustomEvent');
		 	e.initCustomEvent(event, bubbling, cancelable, data);
		}

		target.dispatchEvent(e);
	}

}

export default EventDispatcher;